import request from '@/utils/request'

export function getEquipStatStatusApi(params) {
  return request({
    // url: '?c=rms&a=equip-stat&do=status',
    url: '?c=rms&a=equip&do=overview',
    method: 'get',
    params
  })
}

export function getEquipStatMonthlyApi(params) {
  return request({
    url: '?c=rms&a=equip-stat&do=monthly',
    method: 'get',
    params
  })
}

export function getEquipStatDevlyApi(params) {
  return request({
    url: '?c=rms&a=equip-stat&do=devly',
    method: 'get',
    params
  })
}
